export enum FacingMode {
  Environment = "environment",
  User = "user"
}
